import { Component } from '@angular/core';
import { APIOnLine } from '../../services/api/api.services';
import { ToastController, App, ActionSheetController } from 'ionic-angular';
import { pouchdb2 } from '../../services/pouchdb/pouchdb.service';
import { Navegacion } from '../../models/online/navegacion';
import { ProyectoGanarService } from '../../services/api/ganar.services';

export interface iNuevoMenuDerecho {
  titulo: string;
  componente: any;
  esLocal?: boolean;
  final?: boolean;
}

@Component({
  selector: 'nuevo-menu-derecho',
  templateUrl: 'nuevo-menu-derecho.html'
})
export class NuevoMenuDerechoComponent {

  public navegar: Navegacion.Navegar;

  constructor(
    public actionSheetCtrl: ActionSheetController,
    public appCtrl: App,
    public CFutbolActas: APIOnLine.CFutbolActas,
    public DBService2: pouchdb2.DBService2,
    public Persistentes: APIOnLine.Persistentes,
    public proyectoGanarService: ProyectoGanarService,
    public toastCtrl: ToastController
  ) {
    this.navegar = new Navegacion.Navegar(this.actionSheetCtrl, this.appCtrl, this.CFutbolActas, this.DBService2, this.Persistentes, this.proyectoGanarService, this.toastCtrl);
  }
}



// WEBPACK FOOTER //
// ./src/components/nuevo-menu-derecho/nuevo-menu-derecho.ts